import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Gift({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M4.33341 6.16659C4.33341 4.04949 6.04966 2.33325 8.16675 2.33325H8.50008C9.96751 2.33325 11.2578 3.09183 12.0001 4.23823C12.7424 3.09183 14.0327 2.33325 15.5001 2.33325H15.8334C17.9505 2.33325 19.6667 4.04949 19.6667 6.16659C19.6667 8.28368 17.9505 9.99992 15.8334 9.99992H12.0001H8.16675C6.04966 9.99992 4.33341 8.28368 4.33341 6.16659ZM11.3334 8.66659V6.49992C11.3334 4.93511 10.0649 3.66659 8.50008 3.66659H8.16675C6.78604 3.66659 5.66675 4.78587 5.66675 6.16659C5.66675 7.5473 6.78604 8.66659 8.16675 8.66659H11.3334ZM12.6667 8.66659H15.8334C17.2141 8.66659 18.3334 7.5473 18.3334 6.16659C18.3334 4.78587 17.2141 3.66659 15.8334 3.66659H15.5001C13.9353 3.66659 12.6667 4.93511 12.6667 6.49992L12.6667 8.66659ZM2.66675 11.9999C2.66675 11.6317 2.96522 11.3333 3.33341 11.3333H12.0001H20.6667C21.0349 11.3333 21.3334 11.6317 21.3334 11.9999V20.6666C21.3334 21.0348 21.0349 21.3333 20.6667 21.3333H12.0001H3.33341C2.96522 21.3333 2.66675 21.0348 2.66675 20.6666V11.9999ZM4.00008 12.6666V19.9999H11.3334V12.6666H4.00008ZM12.6667 12.6666V19.9999H20.0001V12.6666H12.6667Z"
        fill={iconColor}
      />
    </Svg>
  );
}
